var React = require('react');

function SocialMailIconInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Grey_Email","data-name":"Grey Email","d":"M67.519,164.945a20.5,20.5,0,1,0,20.5,20.5A20.5,20.5,0,0,0,67.519,164.945Zm13.474,10.943a.95.95,0,0,1,.33.06l-13.272,10.86a1.127,1.127,0,0,1-1.443-.012L53.97,176.083a.954.954,0,0,1,.576-.194Zm0,19.113H54.545a.964.964,0,0,1-.961-.961V178.066L65.469,188.14a2.889,2.889,0,0,0,3.7.032l12.788-10.464V194.04A.964.964,0,0,1,80.993,195Z","transform":"translate(-47.019 -164.945)","fill":"#848484"}));
}

SocialMailIconInline.defaultProps = {"id":"Mail","viewBox":"0 0 41 41"};

module.exports = SocialMailIconInline;

SocialMailIconInline.default = SocialMailIconInline;
